// Core module: This should only depend on other core modules.

import type { LogOptions, LogValues } from './core/logging.ts';
import { log } from './core/logging.ts';
import { isObject } from './identity.ts';
import { Seconds } from './units.ts';

export * from './core/check.ts';
export * from './core/core.ts';
export * from './core/env.ts';
export * from './core/errors.ts';
export * from './core/logging.ts';

export function doNothing() {
  // Do nothing
}

export function doNothingAsync() {
  return Promise.resolve(undefined);
}

export function alwaysTrue() {
  return true;
}

export function alwaysFalse() {
  return false;
}

// An easy, pre-configured temporary log statement for debugging.
// TODO: Use a different header color for easy recognition.
// Example:
//   tempLog('ThingImDebugging', { value: ... });
// N.B. Only use `tempLog` for debugging! Do not check in.
// For long-term logging, use explicitly configured `LogOptions`, as in the example for
// `log()`.
export function tempLog(header: string, values?: LogValues & LogOptions): void {
  // TODO: Is there a better way to keep LogOptions keys in sync?
  values ??= {};
  if (isObject(values)) {
    const {
      /* eslint-disable @typescript-eslint/no-unused-vars */
      density,
      defaultStyle,
      calleeDepth,
      prettyDepth,
      logId,
      rate,
      omitDuplicates,
      emitSkips,
      /* eslint-enable @typescript-eslint/no-unused-vars */
      ...logValues
    } = values;
    values = logValues;
  }
  // TODO: header is not unique enough... it's confusing when we rate limit based on incidental
  // same header. use file/line number
  values.logId ??= Symbol.for(header);
  values.rate ??= Seconds(3);
  values.omitDuplicates ??= true;
  log(header, values, values);
  // {
  //   density,
  //   defaultStyle,
  //   calleeDepth,
  //   prettyDepth,
  //   logId,
  //   rate,
  //   omitDuplicates,
  //   emitSkips,
  // });
}
